import Periods from './List'

export default function PeriodList() {
  return <Periods />
}